import styled from 'styled-components';
import colors from 'theme/colors';
import { TVariant } from './types';

interface IVariantColors {
  sliderBg: string;
  switchColor: string;
  checkedSliderBg: string;
}

export const switchVariants: Record<TVariant, IVariantColors> = {
  default: {
    sliderBg: colors.addBtnBg,
    checkedSliderBg: colors.addBtnBg,
    switchColor: colors.orange,
  },
  secondary: {
    sliderBg: colors.gray,
    checkedSliderBg: colors.blue,
    switchColor: colors.white,
  },
};

export const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
  overflow: hidden;
`;

export const Slider = styled.span<{ variant?: TVariant }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ variant }) =>
    variant ? switchVariants[variant].sliderBg : colors.addBtnBg};
  transition: all 0.4s;
  border-radius: 16px;
  &:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: ${({ variant }) =>
      variant ? switchVariants[variant].switchColor : colors.orange};
    box-shadow:
      0px 0.5px 4px rgba(0, 0, 0, 0.12),
      0px 6px 13px rgba(0, 0, 0, 0.12);
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const Input = styled.input<{ variant?: TVariant }>`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${Slider} {
    background-color: ${({ variant }) =>
      variant ? switchVariants[variant].checkedSliderBg : colors.addBtnBg};
  }

  &:checked + ${Slider}:before {
    transform: translateX(22px);
  }
`;
